import { useState, useEffect } from 'react';
import { getCurrentUserInfo, logout } from '../services/auth';

interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  userId: string | null;
  email: string | null;
}

export function useAuth() {
  // Gated on import.meta.env.DEV so the bypass is tree-shaken from prod builds.
  const isLocal =
    import.meta.env.DEV &&
    import.meta.env.VITE_COGNITO_USER_POOL_ID?.startsWith('local');

  const [state, setState] = useState<AuthState>({
    isAuthenticated: isLocal ? true : false,
    isLoading: isLocal ? false : true,
    userId: isLocal ? 'local-user-123' : null,
    email: isLocal ? 'dev@local.test' : null,
  });

  useEffect(() => {
    if (isLocal) return; // skip Cognito check in local mode
    checkAuth();
  }, [isLocal]);

  async function checkAuth() {
    try {
      const user = await getCurrentUserInfo();
      setState({
        isAuthenticated: true,
        isLoading: false,
        userId: user.userId,
        email: user.signInDetails?.loginId ?? null,
      });
    } catch {
      setState({
        isAuthenticated: false,
        isLoading: false,
        userId: null,
        email: null,
      });
    }
  }

  async function handleLogout() {
    await logout();
    setState({
      isAuthenticated: false,
      isLoading: false,
      userId: null,
      email: null,
    });
  }

  return { ...state, logout: handleLogout, refreshAuth: checkAuth };
}
